import React from 'react';

export const SearchIcon = () => (
  <svg viewBox="0 0 32 32" fill="none" focusable="false" aria-hidden="true">
    <path
      d="M30 28.59 22.45 21A11 11 0 1 0 21 22.45L28.59 30 30 28.59zM5 14a9 9 0 1 1 18 0 9 9 0 0 1-18 0z"
      fill="currentColor"
    />
  </svg>
);
